import React, { useState } from 'react';
import OrderListTemplate, { OrderListActionContext } from '../components/OrderListTemplate';
import { MergedOrder, OrderTabScene } from '../../../types/process/order';
import OrderTriggerActionMap, { OrderTriggerActionProvider, type OrderTriggerTarget } from '../components/OrderTriggerActionMap';
import { useDefaultQueryFields } from '../order.effect';
import { OrderAuditInfo } from '../components/OrderAuditInfo';

/**
 * 待审订单列表页（审核订单 - 待审）
 */
const OrderAuditWaitList: React.FC = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const reloadList = () => setRefreshKey((k) => k + 1);
  const queryFields = useDefaultQueryFields(OrderTabScene.GroupAuditWait);

  const renderListInfo = (order: MergedOrder) => <OrderAuditInfo order={order} />;

  const renderListActions = (order: MergedOrder, ctx?: OrderListActionContext) => {
    const sceneKey = ctx?.scene || '';
    const isPassWaitSendScene = sceneKey === 'tab_audit_wait_pass_wait_send';
    const isTodoScene = sceneKey === 'tab_audit_wait_suspended';
    const isSupplementScene = sceneKey === 'tab_audit_wait_supplement';
    const isAdvanceScene = sceneKey === 'tab_audit_wait_advance';

    const targets: OrderTriggerTarget[] = ['reportView'];

    if (isPassWaitSendScene) {
      targets.push('auditToLock', 'cancelByLogisticsIntercept', 'cancelByShipIntercept');
    } else if (isTodoScene) {
      targets.push('auditToLock', 'auditRelease');
    } else if (isSupplementScene) {
      targets.push('auditDetailView', 'supplementAction');
    } else if (isAdvanceScene) {
      targets.push('auditDetailView', 'prepayAction');
    } else {
      // 默认（所有待审核订单）
      targets.push('auditToLock', 'supplementAction', 'prepayAction');
    }

    return <OrderTriggerActionMap targets={targets} order={order} ctx={ctx} onReload={reloadList} />;
  };

  return (
    <OrderTriggerActionProvider onReload={reloadList}>
      <OrderListTemplate
        refreshKey={refreshKey}
        tabScene={OrderTabScene.GroupAuditWait}
        defaultScene="tab_audit_wait_all"
        queryFields={queryFields}
        tabStyleConfig={{
          importantTabs: ['tab_audit_wait_supplement', 'tab_audit_wait_advance'],
        }}
        viewModes={[
          {
            mode: 'table',
            label: '表格页',
            showField: 'preAudit',
          },
          {
            mode: 'list',
            label: '订单页',
            renderActions: renderListActions,
            renderInfo: renderListInfo,
          },
        ]}
      />
    </OrderTriggerActionProvider>
  );
};

export default OrderAuditWaitList;
